import { render, staticRenderFns } from "./EqifyRulePersonIsInFederation.vue?vue&type=template&id=dd619ef0&scoped=true"
import script from "./EqifyRulePersonIsInFederation.vue?vue&type=script&lang=ts"
export * from "./EqifyRulePersonIsInFederation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd619ef0",
  null
  
)

export default component.exports